module.exports = __webpack_public_path__ + "img/logo-the-fives.35300008.svg";